/** Add a narrow-screen reading order to opted-in, Markdown-generated tables.
 * Keep the table and header associations for assistive technology; only the
 * presentation changes. Links and the original cell HTML remain untouched.
 */
export const stackBlogTables = (html: string): string =>
  html.replace(
    /<table>\s*<thead>([\s\S]*?)<\/thead>\s*<tbody>([\s\S]*?)<\/tbody>\s*<\/table>/g,
    (_table, head: string, body: string) => {
      const labels = Array.from(head.matchAll(/<th(?:\s[^>]*)?>([\s\S]*?)<\/th>/g), match =>
        match[1].replace(/<[^>]*>/g, "").trim(),
      );
      const header = head
        .replace(/<tr>/g, '<tr role="row">')
        .replace(/<th(\s[^>]*)?>/g, '<th$1 scope="col" role="columnheader">');
      const rows = body.replace(/<tr>([\s\S]*?)<\/tr>/g, (_row: string, cells: string) => {
        let index = 0;
        const labeledCells = cells.replace(
          /<td(\s[^>]*)?>([\s\S]*?)<\/td>/g,
          (_cell: string, attributes: string | undefined, value: string) => {
            const label = labels[index++];
            return `<td${attributes ?? ""} role="cell"><span class="blog-table-label" aria-hidden="true">${label ?? ""}</span><span class="blog-table-value">${value}</span></td>`;
          },
        );
        return `<tr role="row">${labeledCells}</tr>`;
      });
      return `<table class="blog-comparison-table" role="table"><thead role="rowgroup">${header}</thead><tbody role="rowgroup">${rows}</tbody></table>`;
    },
  );
